angular.module('env.data.services.loginShadowService', [])

    .run(function (authService, loginShadowService, gettextCatalog, toastr) {
        authService.events.on('sessionExpired', function () {
            loginShadowService.show();
            toastr.warning(gettextCatalog.getString('Your session expired. Please, log in.'), gettextCatalog.getString('Session expired'));
        });
    })

    .service("loginShadowService", function ($compile, $rootScope, $q) {
        var _this = this;
        var scope;
        var el;
        var deferred;

        _this.show = function () {
            if (deferred) {
                return deferred;
            }
            deferred = $q.defer();
            scope = $rootScope.$new(true);
            el = $compile("<login-shadow></login-shadow>")(scope);
            angular.element("body").append(el);
            return deferred;
        };

        _this.close = function () {
            if (scope) {
                scope.$destroy();
                el.remove();
                scope = null;
                el = null;
            }
            if (deferred) {
                deferred.resolve();
                deferred = null;
            }
        };

        return _this;
    })

;